import * as React from 'react';

import { classNames } from '@core/utils/functions/class-names';
import Link from 'next/link';

type FeaturedWebinarProps = {
    title: string;
    smallHeadline: string;
    url: string;
    podcastShowTitle?: string;
    description?: string;
    showMoreUrl: string;
    sponsoredBy?: string;
    className?: string;
};

const FeaturedWebinar = (props: FeaturedWebinarProps) => {
    const { title, smallHeadline, url, description, showMoreUrl, sponsoredBy, className } = props;

    return (
        <div className={classNames('flex flex-col justify-start items-start gap-3 p-10', className)}>
            <div className="flex flex-col justify-start self-stretch gap-2">
                <div className="flex justify-start items-center self-stretch gap-1">
                    <p className="flex-grow text-xs uppercase text-primary">{smallHeadline}</p>
                </div>
                <div className="flex justify-start items-start self-stretch gap-2.5">
                    <Link href={url} target="_blank" rel="noreferrer">
                        <a className="flex-grow text-[22px] font-headline hover:text-primary">{title}</a>
                    </Link>
                </div>
                {sponsoredBy && (
                    <p className="flex-grow-0 flex-shrink-0 text-sm text-left text-[#6a6a6a]">
                        Sponsored by
                        <span className="text-black ml-1">{sponsoredBy}</span>
                    </p>
                )}
                <div className="flex justify-start items-start self-stretch gap-2.5">
                    <p className="flex-grow text-base text-left text-[#6a6a6a]">{description}</p>
                </div>
                <div className="flex justify-start items-start self-stretch gap-1">
                    <Link href={showMoreUrl} target="_blank" rel="noreferrer">
                        <a className="flex justify-start items-center flex-grow-0 flex-shrink-0 relative gap-0.5">
                            <span className="flex justify-start items-center flex-grow-0 flex-shrink-0 relative gap-1">
                                <span className="flex-grow-0 flex-shrink-0 text-xs text-left uppercase text-[#5637cd]">
                                    register
                                </span>
                            </span>
                            <svg
                                width={10}
                                height={11}
                                viewBox="0 0 10 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="flex-grow-0 flex-shrink-0 w-2.5 h-2.5 relative"
                                preserveAspectRatio="xMidYMid meet"
                            >
                                <path
                                    d="M6.67214 5.08203H1.66797V5.91536H6.67214V7.16536L8.33464 5.4987L6.67214 3.83203V5.08203Z"
                                    fill="#5637CD"
                                />
                            </svg>
                        </a>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default FeaturedWebinar;
